import { trpc } from '../../../hooks/trpc'

type UseResolvedTilledAccountRequest = {
  companyGuid: string
  paymentMethodRecordGuid?: string
  paymentSubscriptionGuid?: string
  authenticated: boolean
}

export const useResolvedTilledAccount = ({
  companyGuid,
  paymentMethodRecordGuid,
  paymentSubscriptionGuid,
  authenticated,
}: UseResolvedTilledAccountRequest) => {
  const input = { companyGuid, paymentMethodRecordGuid, paymentSubscriptionGuid }
  const authorized = trpc.payments['payments:resolve-tilled-account'].useQuery(input, { enabled: authenticated })
  const unauthenticated = trpc.payments['unauth:payments:resolve-tilled-account'].useQuery(input, {
    enabled: !authenticated,
  })
  const result = authenticated ? authorized : unauthenticated
  const hasResolvedData = result.data !== undefined
  return {
    merchantId: result.data?.merchantId,
    error: hasResolvedData ? undefined : result.error,
    isLoading: !hasResolvedData && (result.isLoading || result.isFetching),
    retry: result.refetch,
  }
}
